"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StarRating_1 = require("./StarRating");
exports.default = StarRating_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/StarRating/index.js
// module id = 460
// module chunks = 8